import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { StaffType } from './staff-type';
export { StaffType };
import { staffTypeSchema } from '@schemas/business-objects/staff-type';
import { CandidateFormArray } from './candidate-form-group';
import { PositionFormArray } from './position-form-group';

export class StaffTypeFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    description: SchemaFormControl;
    candidates: CandidateFormArray;
    positions: PositionFormArray;
  };

  declare value: Partial<StaffType>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(staffTypeSchema, StaffType, data, options);
  }

  get object(): StaffType {
    return new StaffType(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidates':
        return new CandidateFormArray();
      case 'positions':
        return new PositionFormArray();
      default:
        return undefined;
    }
  }
}

export class StaffTypeFormArray extends PersistedFormArray {
  readonly entityName = 'StaffType' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(staffTypeSchema, StaffType, options);
  }

  protected override createItemGroup() {
    return new StaffTypeFormGroup();
  }

  get array(): StaffType[] {
    return this.controls.map((group: StaffTypeFormGroup) => group.object);
  }
}

export class StaffTypePersistedArray extends PersistedArray<StaffType> {
  readonly entityName = 'StaffType' as const;

  constructor(options?: PersistedArrayOptions) {
    super(StaffType, options);
  }
}
